/* eslint-disable @typescript-eslint/no-explicit-any */
import { safeLocalStorage } from '../lib/storage/safeLocalStorage';

export const setLocalStorageWithExpiry = (
  key: string,
  value: any,
  ttl: number = 1000 * 60 * 60
) => {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  safeLocalStorage.setItem(key, JSON.stringify(item));
};

export const getFromLocalStorageWithExpiry = (key: string) => {
  const itemStr = safeLocalStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    safeLocalStorage.removeItem(key);
    return null;
  }
  return item.value;
};
